module.exports = __webpack_public_path__ + "img/km.0d3a986d.svg";